package link.erpango.quip.data.firebase.config

import link.erpango.quip.data.firebase.IFirebaseClient

class FirebaseRemoteConfig(

    private val client: IFirebaseClient

): IFirebaseRemoteConfig